import { makeStyles, type Theme } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles<Theme>(
  (theme) => ({
    root: {
      width: 175,
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.75),
    },
    button: {
      flex: 1,
    },
    progress: {
      flex: 1,
    },
    label: {
      flex: 1,
      color: COLORS.gray.gray30,
      whiteSpace: 'nowrap',
    },
    icon: {
      fontSize: theme.typography.pxToRem(16),
      marginLeft: theme.spacing(1.5),
    },
  }),
  { name: 'ComplianceControl' }
);
